// Third Party
import React from 'react';

// Components
import { EditContact } from '../edit-contact';
import { CloseButton } from '../buttons';
import Modal from '@/views/components/modals/AccessibleModal';

// Constants and types
import GenericContact from '@/types/generic-contact';
import User from '@/types/user';
import { EditBMOContact } from '../bmo-gif';

// Utils
import { PERMISSIONS, userHasPermissionEnabled } from '@/utils/permissions';
import { BMO_CONTACT_TYPE } from '@/utils/bmo-gif/constants';

type Props = {
  user: User;
  show: boolean;
  onCancel: () => void;
  onSave: (contact: GenericContact) => void;
  contact?: GenericContact;
  isEditing?: boolean;
  saveLabelId?: string;
};

const EditContactModal = (props: Props) => {
  const isGIF = userHasPermissionEnabled(props.user, PERMISSIONS.BMO_GIF) && props.contact?.type === BMO_CONTACT_TYPE;

  return (
    <Modal show={props.show} className="edit-contact-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
      <Modal.Header>{!!props.onCancel && <CloseButton onClick={props.onCancel} />}</Modal.Header>

      <Modal.Body className="d-flex flex-column">
        {!isGIF && (
          <EditContact user={props.user} onSave={props.onSave} onCancel={props.onCancel} isEditing={props.isEditing} saveLabelId={props.saveLabelId} />
        )}
        {isGIF && props.isEditing && props.contact && <EditBMOContact compact contact={props.contact} onSave={props.onSave} onCancel={props.onCancel} />}
      </Modal.Body>
    </Modal>
  );
};

export default EditContactModal;
